import AboutMidContent from "../../components/about/AboutMidContent";
import Footer from "../../components/layout/Footer";
import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import img from "../../assets/images/about/about.jpg";
import headerImg from "../../assets/images/background/13.jpg";
import { useTranslation } from "react-i18next";

function Values() {
  const { t } = useTranslation();

  return (
    <>
      <MainHeader />
      <PageHeader image={headerImg} title={t("Values")} />
      <AboutMidContent
        title={t("Our Values")}
        subTitle={t("Our Values")}
        text1={
          <>
            <p>{t("excellence")}</p>
            <p>{t("commitment")}</p>
            <p>{t("safety")}</p>
            <p>{t("professional_integrity")}</p>
            <p>{t("social_responsibility")}</p>
          </>
        }
        image={img}
      />

      <Footer />
    </>
  );
}

export default Values;
